<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2" @click="$router.push('/choferes')">
        <i class="fas fa-arrow-left"></i> {{$t('volver')}}
      </b-button>

      <b-card-header class="border-0">
        <h3 class="mb-0">Chofer: {{ chofer.nombre }} {{ chofer.apellido }}</h3>
      </b-card-header>

      <b-form @submit.prevent="submitForm">
        <div class="d-flex justify-content-end">
          <b-button @click="isEditMode = !isEditMode" :variant="!isEditMode ? 'info' : 'danger'">
            {{ !isEditMode ? $t('editar') : $t('cancelar') }}
          </b-button>

          <b-button v-if="isEditMode" :disabled="!isEditMode" type="submit" variant="primary" class="ml-2">
            {{ $t('actualizar') }} 
          </b-button>
        </div>
        <b-row>
          <b-col md="3">
            <b-form-group label-for="Nombre">
              <template v-slot:label>
                {{$t('nombre')}} <span v-if="isEditMode" class="text-danger">*</span>
              </template>
              <b-form-input id="nombre" :disabled="!isEditMode" v-model="chofer.nombre" required
                placeholder="Ingrese nombre"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label-for="Apellido">
              <template v-slot:label>
                {{$t('apellido')}}  <span v-if="isEditMode" class="text-danger">*</span>
              </template>
              <b-form-input id="apellido" :disabled="!isEditMode" v-model="chofer.apellido" required
                placeholder="Ingrese apellido"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label-for="Rut">
              <template v-slot:label>
                {{$t('rut')}}  <span v-if="isEditMode" class="text-danger">*</span>
              </template>
              <b-form-input id="rut" :disabled="!isEditMode" v-model="chofer.rut" required
                placeholder="Ingrese Rut"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </base-header>
  </div>
</template>
<script>
import choferService from '@/api/choferService';

export default {
  data() {
    return {
      isEditMode: false,
      chofer: {},
    };
  },
  async beforeMount() {
    const id = this.$route.params.id;

    this.chofer = await choferService.get(id);
  },
  methods: {
    async submitForm() {
      Swal.fire({
        title: this.$t('estas_seguro'),
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('aceptar'),
        denyButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('guardando')}</h3>
                        </div>
                    </div>`,
              showConfirmButton: false,
              allowOutsideClick: false
            });
            const response = await choferService.update(this.chofer, this.chofer.id);
            if (!response) throw new Error(this.$t('error_guardar'));
            this.chofer = await choferService.get(this.chofer.id);
            this.isEditMode = false;
            Swal.fire({
              title: this.$t('cambios_guardados'),
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              background: '#f8f9fa',
              customClass: {
                title: 'swal-title',
                icon: 'swal-icon',
              },
            });
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: this.$t('error_2'),
            });
          }
        } else if (result.isDenied) {
          Swal.close();
        }
      });
    }
  },
};
</script>
<style>
.el-table.table-dark {
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}
</style>
